import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useMutation } from 'react-query'
import { VideoScriptRequestParams } from 'utils/videoScriptRequest'
import { waitForVoiceoverScript } from './waitForVoiceoverScript'

export type GenerateVideoScriptResponse =
  | { supported: false; reason: string; token?: undefined }
  | { supported: true; token: string; reason?: undefined }

export const postGenerateVideoScript = async (
  workspaceId: number,
  params: VideoScriptRequestParams,
): Promise<GenerateVideoScriptResponse> => {
  const res = await sendToApi<GenerateVideoScriptResponse>(`/w/${workspaceId}/videos/generate_script`, {
    method: 'POST',
    body: params,
  })
  if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error('Failed to start video script generation')
  return res.data
}

export const useGenerateVideoScript = () => {
  const workspaceId = useCurrentWorkspaceId()
  const websocketConnection = useWebsocketConnection()

  return useMutation<string, Error, VideoScriptRequestParams & { existingToken?: string | null }>(
    async (params) => {
      const { existingToken, ...requestParams } = params
      let token = existingToken ?? null

      if (!token) {
        const startRes = await postGenerateVideoScript(workspaceId, requestParams)
        if (!startRes.supported) {
          throw new Error(startRes.reason || 'Video script generation is not supported')
        }
        token = startRes.token
      }

      if (!websocketConnection) throw new Error('Websocket connection unavailable')
      return waitForVoiceoverScript(websocketConnection, token)
    },
  )
}
